export default {
  name: "ProductDetail",

  mounted() {
    if (this.$refs.slider) {
      this.$options.slider = new Swipe(this.$refs.slider, {
        startSlide: 0,
        auto: 6000,
        draggable: true,
        autoRestart: false,
        continuous: true,
        disableScroll: true,
        stopPropagation: true,
        // callback: function(index, element) {},
        // transitionEnd: function(index, element) {}
      });
    }

    if (this.$refs.imagesWrapper) {
      Array
        .from(this.$refs.imagesWrapper.querySelectorAll("img"))
        .forEach(img => {
          img.addEventListener("mousedown", this.mouseHandler);
          img.addEventListener("mouseup", this.mouseHandler);
        });
    }
  },

  methods: {
    prev() {
      this.$options.slider.prev();
    },

    next() {
      this.$options.slider.next();
    },

    mouseHandler(e) {
      if (e.type === "mousedown") {
        this.$options.mouseDownTimestamp = Date.now()
      }
      if (e.type === "mouseup") {
        if (!this.$options.mouseDownTimestamp) {
          return;
        }
        const timestampDiff = Date.now() - this.$options.mouseDownTimestamp;
        if (timestampDiff <= 80) {
          const img = e.target.cloneNode(true);
          img.removeAttribute("style");
          img.removeAttribute("data-index");
          window.sette.emitter.$emit("lightbox.toggle", img.outerHTML);
        }
      }
    }
  }
};